<template>
  <div>
    <v-row align="center" justify="center">
      <v-col v-if="!$apollo.loading" cols="12" align="center" class="pl-8">
        <v-row>
          <v-col align="left">
            <router-link
              v-if="coachId"
              class="subtitle-1 grey-navy--text font-weight-bold text-decoration-none"
              to="/reporting/engagement/coaching"
            >
              <v-icon small class="pb-1"> keyboard_backspace </v-icon> Coaches
            </router-link>
          </v-col>
          <v-col align="center">
            <div class="d-flex justify-center">
              <h1>{{ coach.firstName }}'s Dashboard</h1>

              <v-btn icon @click="copyCalendly()" class="ml-1 my-auto">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" slot="activator">
                      <v-icon :color="copyCalendlyText === 'Calendly link copied' ? 'green' : null"
                        >mdi-content-copy</v-icon
                      >
                    </div>
                  </template>
                  <span>{{ copyCalendlyText }}</span>
                </v-tooltip>
              </v-btn>
            </div>
            <!-- 
            <h3>
              How are you feeling, {{ coach.firstName }}?
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    slot="activator"
                    @click="updateFeeling()"
                    large
                    :color="selectedFeeling.color"
                    class="ml-2 mb-1 pointer"
                  >
                    {{ selectedFeeling.icon }}
                  </v-icon>
                </template>
                <span>{{ selectedFeeling.message }}</span>
              </v-tooltip>
            </h3> -->
          </v-col>
          <v-col align="right">
            Last updated: {{ ago }}
            <v-btn icon @click="update()">
              <v-icon color="secondary">mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <header-pill
              :coach-id="coachId"
              :last-update="lastUpdated"
              tooltip="Onboarding"
              icon="mdi-shimmer"
              :subscription-count="coachingSubscriptionNumbers.onboarding.subscriptionCount"
              dashboard="CoachingOnboardingSubscription"
              :tasks="coachingSubscriptionNumbers.onboarding.unresolvedChats"
            />
            <header-pill
              :coach-id="coachId"
              :last-update="lastUpdated"
              tooltip="One-on-one"
              icon="mdi-numeric-1-box-multiple-outline"
              :subscription-count="coachingSubscriptionNumbers.oneOnOne.subscriptionCount"
              dashboard="CoachingOneOnOneSubscription"
              :tasks="coachingSubscriptionNumbers.oneOnOne.unresolvedChats"
            />
            <header-pill
              :coach-id="coachId"
              :last-update="lastUpdated"
              tooltip="Weekly"
              icon="mdi-school"
              :subscription-count="coachingSubscriptionNumbers.grad.subscriptionCount"
              dashboard="CoachingGradSubscription"
              :tasks="coachingSubscriptionNumbers.grad.unresolvedChats"
            />
            <header-pill
              :coach-id="coachId"
              :last-update="lastUpdated"
              tooltip="Club"
              icon="mdi-cards-club"
              :subscription-count="coachingSubscriptionNumbers.club.subscriptionCount"
              dashboard="CoachingClubSubscription"
              :tasks="coachingSubscriptionNumbers.club.unresolvedChats"
            />
            <header-pill
              :coach-id="coachId"
              :last-update="lastUpdated"
              tooltip="Package"
              icon="mdi-package-variant-closed"
              :subscription-count="coachingSubscriptionNumbers.package"
              dashboard="CoachingPackageSubscription"
            />
            <header-pill
              :coach-id="coachId"
              :last-update="lastUpdated"
              tooltip="Client-sitting"
              icon="mdi-account-child"
              :subscription-count="coachingSubscriptionNumbers.clientSitting.subscriptionCount"
              dashboard="CoachingSecondarySubscription"
              :tasks="coachingSubscriptionNumbers.clientSitting.unresolvedChats"
            />
            <header-pill
              :coach-id="coachId"
              :last-update="lastUpdated"
              tooltip="Offboarding"
              icon="mdi-hand-wave-outline"
              :subscription-count="coachingSubscriptionNumbers.offboarding"
              dashboard="CoachingOffboardingSubscription"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="py-0 mb-0 mt-n8" align="center" justify="center">
      <v-col cols="12" align="center" justify="center">
        <div v-if="$apollo.loading">
          <v-skeleton-loader type="heading, paragraph" width="50%" />
          <v-skeleton-loader type="table" />
        </div>
        <router-view v-else :last-updated="lastUpdated" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  COACH_QUERY,
  SET_FEELING_MUTATION,
  COACH_FEELING_QUERY,
  COACHING_CLIENT_NUMBERS_QUERY,
} from "@/constants/graphql/coach/coaching";
import FeelingMixin from "@/components/shared/mixins/FeelingMixin";
import HeaderPill from "@/components/dashboard/components/header/HeaderPill";

export default {
  name: "ClientDashboardBase",
  components: {
    HeaderPill,
  },
  mixins: [FeelingMixin],
  props: {
    coachId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      coach: "",
      copyCalendlyText: "Copy Calendly Link",
      problemConnecting: false,
      problemConnectingText:
        "\nYou may be experiencing some internet connectivity issues. Please refresh your page and try again." +
        "\nReach out to tech support if you continue to have issues as your changes will not be saved.",
      ago: "",
      today: null,
      coachingSubscriptionNumbers: {},
      selectedFeeling: null,
    };
  },
  created() {
    this.lastUpdated = this.$moment().format("YYYY-MM-DD HH:mm:ss");
    this.ago = this.$moment(this.lastUpdated).fromNow();
    this.today = this.$moment().format("YYYY-MM-DD");

    if (!this.selectedFeeling) {
      this.selectedFeeling = this.feelings[0];
    }

    setInterval(() => {
      this.ago = this.$moment(this.lastUpdated).fromNow();
    }, 60000);
  },
  methods: {
    async copyCalendly() {
      await navigator.clipboard.writeText(this.coach?.userProfile?.assessmentBookingLink);
      this.copyCalendlyText = "Calendly link copied";
    },
    update() {
      this.lastUpdated = this.$moment();
      this.ago = this.$moment(this.lastUpdated).fromNow();
      this.today = this.$moment().format("YYYY-MM-DD");

      this.$apollo.queries.coachingSubscriptionNumbers?.refetch();
      this.$apollo.queries.coachFeeling?.refetch();
    },
    updateFeeling() {
      let newFeelingIndex = this.selectedFeeling.index + 1;
      if (newFeelingIndex >= this.feelings.length) {
        newFeelingIndex = 0;
      }
      this.selectedFeeling = this.feelings[newFeelingIndex];

      this.$apollo
        .mutate({
          mutation: SET_FEELING_MUTATION,
          variables: {
            coachId: this.coachId,
            feelingIndex: newFeelingIndex,
            feelingDate: this.$moment().format("YYYY-MM-DD"),
          },
        })
        .catch((error) => {
          alert(error);
        });
    },
    alertProblem() {
      alert(`Something went wrong. \n\n${this.problemConnectingText}`);
    },
  },
  apollo: {
    coachingSubscriptionNumbers: {
      query: COACHING_CLIENT_NUMBERS_QUERY,
      variables() {
        return {
          userId: this.coachId,
        };
      },
      fetchPolicy: "cache-and-network",
    },
    coach: {
      query: COACH_QUERY,
      variables() {
        return {
          id: this.coachId,
        };
      },
      fetchPolicy: "cache-and-network",
    },
    coachFeeling: {
      query: COACH_FEELING_QUERY,
      variables() {
        return {
          id: this.coachId,
          today: this.$moment().format("YYYY-MM-DD"),
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          if (response.data.coachFeeling) {
            this.selectedFeeling = this.feelings[response.data.coachFeeling.feelingIndex];
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.limited-height {
  height: 650px;
}
.thicker-border {
  border-width: 2px;
}
</style>
